import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import { columnsRequestPayments, } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { listRequestPayments, updateStatus } from "../../Redux/Actions/paymentsActions";
import toast from "react-hot-toast";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { Modal, Input } from "antd";

const ListRequestPaymentsRefund = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [rejectPopupVisible, setRejectPopupVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [loadingReject, setLoadingReject] = useState(false);
  const [approvePopupVisible, setApprovePopupVisible] = useState(false);
  const [selectedApprovalRecord, setSelectedApprovalRecord] = useState(null);
  const [loadingApprove, setLoadingApprove] = useState(false);
  const [viewReasonVisible, setViewReasonVisible] = useState(false);
  const [viewReasonRecord, setViewReasonRecord] = useState(null);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });


  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, pageSize, showLoader = true) => {
      const payload = {
        page,
        limit: pageSize,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };
      dispatch(listRequestPayments(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh payment history list");
        }
      });
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const { paymentsRequest } = useSelector((state) => state.payments || {});
  const loading = useSelector((state) => state.payments?.loading);

  useEffect(() => {
    if (paymentsRequest?.total) {
      setPagination((prevData) => ({ ...prevData, total: paymentsRequest.total }));
    }
  }, [paymentsRequest]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPagination(prev => ({ ...prev, current: 1 }));
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const openViewReasonPopup = (record) => {
    setViewReasonRecord(record);
    setViewReasonVisible(true);
  };

  // const handleStatusChange = async (record, action, refundReason = "") => {
  //   const payload = {
  //     booking_id: record.booking_id,
  //     status: action,
  //     refund_reason_from_admin: refundReason,
  //   };

  //   if (action === "approved") {
  //     payload.status = "approved";
  //   } else if (action === "rejected") {
  //     payload.status = "rejected";
  //   } else {
  //     payload.status = action;
  //   }

  //   await dispatch(updateStatus(record._id, payload));
  //   fetchDetails(pagination.current, pagination.pageSize); // refresh list
  // };

  // const filterHandler = () => {
  //   setSearchQuery(tempSearch);
  //   setPagination((prev) => ({ ...prev, current: 1 }));
  // };

  // Open approval popup when approved clicked
  const openApprovePopup = (record) => {
    setSelectedApprovalRecord(record);
    setApprovePopupVisible(true);
  };

  // Submit approval
  const submitApprove = async () => {
    setLoadingApprove(true);
    try {
      await handleStatusChange(selectedApprovalRecord, "approved");
      toast.success("Payment request approved successfully.");
      setApprovePopupVisible(false);
    } catch (error) {
      toast.error("Failed to approve payment request.");
    }
    setLoadingApprove(false);
  };


  const handleStatusChange = async (record, action, refundReason = "") => {
    const payload = {
      booking_id: record.booking_id,
      status: action,
      refund_reason_from_admin: refundReason,
    };

    if (action === "approved") {
      payload.status = "approved";
    } else if (action === "rejected") {
      payload.status = "rejected";
    } else {
      payload.status = action;
    }

    await dispatch(updateStatus(record._id, payload));
    fetchDetails(pagination.current, pagination.pageSize); // refresh list
  };

  // Open rejection popup when rejected clicked
  const openRejectPopup = (record) => {
    setSelectedRecord(record);
    setRejectReason("");
    setRejectPopupVisible(true);
  };

  // Submit rejection with reason
  const submitReject = async () => {
    if (!rejectReason.trim()) {
      toast.error("Please enter a rejection reason.");
      return;
    }
    setLoadingReject(true);
    try {
      await handleStatusChange(selectedRecord, "rejected", rejectReason.trim());
      toast.success("Payment request rejected successfully.");
      setRejectPopupVisible(false);
    } catch (error) {
      toast.error("Failed to reject payment request.");
    }
    setLoadingReject(false);
  };

  return (
    <>
      <TableComponentsCp
        dataSource={Array.isArray(paymentsRequest?.data) ? paymentsRequest.data : []}
        pagination={pagination}
        onChange={handleTableChange}
        columns={columnsRequestPayments(pagination.current, pagination.pageSize, handleStatusChange, openRejectPopup, openApprovePopup, openViewReasonPopup)}
        h3heading="Request Payment List"
        loading={loading}
        setState={setSearchQuery}
        onCalendarClick={() => setIsDatePopupVisible(true)}
      />

      {/* Rejection Modal */}
      <Modal
        title="Enter Rejection Reason"
        visible={rejectPopupVisible}
        onOk={submitReject}
        onCancel={() => setRejectPopupVisible(false)}
        okButtonProps={{
          disabled: loadingReject,
          style: { backgroundColor: "#0D152B", color: "white", border: "none" },
        }}
        cancelButtonProps={{ disabled: loadingReject }}
        confirmLoading={loadingReject}
      >
        <Input.TextArea
          rows={4}
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          placeholder="Write rejection reason here..."
          disabled={loadingReject}
        />
      </Modal>

      {/* Approval Modal */}
      <Modal
        title="Confirm Approval"
        visible={approvePopupVisible}
        onOk={submitApprove}
        onCancel={() => setApprovePopupVisible(false)}
        okButtonProps={{
          disabled: loadingApprove,
          style: { backgroundColor: "#0D152B", color: "white", border: "none" },
        }}
        cancelButtonProps={{ disabled: loadingApprove }}
        confirmLoading={loadingApprove}
      >
        <p>Are you sure you want to approve this payment request?</p>
      </Modal>

      <Modal
        title="Rejected Refund Reason"
        visible={viewReasonVisible}
        onCancel={() => setViewReasonVisible(false)}
        footer={null}
      >
        <p>{viewReasonRecord?.refund_reason_from_admin || "No reason provided."}</p>
      </Modal>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />

    </>

  );
};

export default ListRequestPaymentsRefund;
